(() => {
  const shell = document.querySelector('[data-lg-unified-header]');
  const header = shell?.querySelector('[data-lg-header]');
  if (!shell || !header) return;

  const desktopEquipment = header.querySelector('[data-lg-equipment]');
  const mobileMenu = header.querySelector('[data-lg-mobile-menu]');
  const mobileEquipment = header.querySelector('[data-lg-mobile-equipment]');
  const searchToggle = header.querySelector('[data-lg-search-toggle]');
  const searchForm = header.querySelector('[data-lg-search-form]');
  const searchInput = searchForm?.querySelector('input[type="search"]');
  let desktopOpenedByHover = false;
  let desktopCloseTimer = 0;

  const cancelDesktopClose = () => {
    if (desktopCloseTimer) window.clearTimeout(desktopCloseTimer);
    desktopCloseTimer = 0;
  };
  const syncDetails = (details) => {
    const summary = details?.querySelector('summary');
    summary?.setAttribute('aria-expanded', String(details.open));
    if (details === mobileMenu) {
      summary?.setAttribute('aria-label', details.open ? 'Close navigation menu' : 'Open navigation menu');
    }
  };
  const closeEquipment = () => {
    cancelDesktopClose();
    [desktopEquipment, mobileEquipment].forEach((details) => {
      if (!details) return;
      details.open = false;
      syncDetails(details);
    });
    desktopOpenedByHover = false;
  };
  const closeMobileMenu = (restoreFocus = false) => {
    if (!mobileMenu) return;
    mobileMenu.open = false;
    syncDetails(mobileMenu);
    if (restoreFocus) mobileMenu.querySelector('[data-lg-mobile-toggle]')?.focus();
  };
  const closeSearch = (restoreFocus = false) => {
    if (!searchForm || !searchToggle || searchForm.hidden) return;
    searchForm.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.setAttribute('aria-label', 'Open search');
    if (restoreFocus) searchToggle.focus();
  };

  searchToggle?.setAttribute('aria-expanded', 'false');
  syncDetails(desktopEquipment);
  syncDetails(mobileMenu);
  syncDetails(mobileEquipment);

  let condensed = false;
  let scrollScheduled = false;
  const updateHeaderState = () => {
    scrollScheduled = false;
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    const next = condensed ? y > 42 : y > 76;
    if (next !== condensed) {
      condensed = next;
      header.classList.toggle('lgn-is-condensed', condensed);
    }
  };
  window.addEventListener('scroll', () => {
    if (scrollScheduled) return;
    scrollScheduled = true;
    window.requestAnimationFrame(updateHeaderState);
  }, { passive: true });
  window.addEventListener('pageshow', updateHeaderState, { passive: true });
  updateHeaderState();

  if (desktopEquipment) {
    const summary = desktopEquipment.querySelector('summary');
    desktopEquipment.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      cancelDesktopClose();
      if (!desktopEquipment.open) {
        desktopEquipment.open = true;
        desktopOpenedByHover = true;
        syncDetails(desktopEquipment);
      }
    });
    desktopEquipment.addEventListener('pointerleave', () => {
      cancelDesktopClose();
      desktopCloseTimer = window.setTimeout(() => {
        desktopOpenedByHover = false;
        if (!desktopEquipment.contains(document.activeElement)) {
          desktopEquipment.open = false;
          syncDetails(desktopEquipment);
        }
        desktopCloseTimer = 0;
      }, 200);
    });
    summary?.addEventListener('click', (event) => {
      event.preventDefault();
      cancelDesktopClose();
      if (desktopOpenedByHover) {
        desktopOpenedByHover = false;
        desktopEquipment.open = true;
      } else {
        desktopEquipment.open = !desktopEquipment.open;
      }
      syncDetails(desktopEquipment);
    });
    summary?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        cancelDesktopClose();
        desktopEquipment.open = true;
        syncDetails(desktopEquipment);
        desktopEquipment.querySelector('.lgn-equipment-panel a')?.focus();
      }
    });
    desktopEquipment.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!desktopEquipment.matches(':hover') && !desktopEquipment.contains(document.activeElement)) {
          cancelDesktopClose();
          desktopEquipment.open = false;
          desktopOpenedByHover = false;
          syncDetails(desktopEquipment);
        }
      }, 0);
    });
    desktopEquipment.addEventListener('toggle', () => syncDetails(desktopEquipment));
  }

  mobileMenu?.addEventListener('toggle', () => {
    syncDetails(mobileMenu);
    if (mobileMenu.open) {
      closeEquipment();
      closeSearch();
    }
  });
  mobileEquipment?.addEventListener('toggle', () => syncDetails(mobileEquipment));
  mobileMenu?.querySelectorAll('.lgn-mobile-panel a').forEach((link) => {
    link.addEventListener('click', () => closeMobileMenu());
  });

  searchToggle?.addEventListener('click', () => {
    if (!searchForm || !searchInput) return;
    closeEquipment();
    closeMobileMenu();
    const opening = searchForm.hidden;
    searchForm.hidden = !opening;
    searchToggle.setAttribute('aria-expanded', String(opening));
    searchToggle.setAttribute('aria-label', opening ? 'Close search' : 'Open search');
    if (opening) searchInput.focus();
  });

  document.addEventListener('pointerdown', (event) => {
    if (!header.contains(event.target)) {
      closeEquipment();
      closeMobileMenu();
      closeSearch();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (searchForm && !searchForm.hidden) {
      event.preventDefault();
      closeSearch(true);
      return;
    }
    if (desktopEquipment?.open) {
      event.preventDefault();
      closeEquipment();
      desktopEquipment.querySelector('summary')?.focus();
      return;
    }
    if (mobileEquipment?.open) {
      event.preventDefault();
      mobileEquipment.open = false;
      syncDetails(mobileEquipment);
      mobileEquipment.querySelector('summary')?.focus();
      return;
    }
    if (mobileMenu?.open) {
      event.preventDefault();
      closeMobileMenu(true);
    }
  });
})();
